function loadEPolicyModule(component) {
  return () => import(`@/components/e-policy/${component}.vue`)
}

export default [
  {
    name: 'e-policy',
    path: '/e-policy',
    component: () => import(/* webpackChunkName: "e-policy-view-page" */ '../view/EPolicyView.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: 'e-policy.history',
        path: 'history',
        component: loadEPolicyModule('Index'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'e-policy.uploadFile',
        path: 'upload-file',
        component: loadEPolicyModule('UploadEPolicy'),
        props: true,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
